
import Article from "@soenergy/frontend-library/src/components/Article"
import AppSection from "@soenergy/frontend-library/src/components/AppSection"
import "@pqina/flip/dist/flip.min.css"

export default {
  components: {
    AppSection,
    Article
  },
  props: {
    heading: {
      type: String,
      required: true
    },
    subheading: {
      type: String,
      required: true
    },
    fontColor: {
      type: String,
      default: ""
    },
    backgroundColor: {
      type: String,
      default: ""
    },
    firstFigureIcon: {
      type: Object,
      default: () => {}
    },
    secondFigureIcon: {
      type: Object,
      default: () => {}
    },
    firstFigureCopy: {
      type: Object,
      default: null
    },
    secondFigureCopy: {
      type: Object,
      default: null
    },
    savedMWh: {
      type: String,
      default: null
    }
  },
  watch: {
    savedMWh(newValue) {
      this._tick.value = Number(newValue)
    }
  },
  async mounted() {
    this.$flip = (await import("@pqina/flip")).default
    this._tick = this.$flip.DOM.create(this.$refs.tick, {
      value: 0
    })
  },
  destroyed() {
    if (this.$flip) {
      this.$flip.DOM.destroy(this.$refs.tick)
    }
  },
  methods: {
    elementCameInToView(isVisible) {
      if (!isVisible || this.started) {
        return
      }
      this.started = true
      this.startAnimation()
    },
    startAnimation() {
      this._tick.value = Number(this.savedMWh)
    }
  }
}
